import { atom } from 'jotai';
import { onbekendId } from './grond-gebruiken';

interface VerdelingGrondsoort {
  grondsoortcategorieId: number;
  [key: string]: unknown;
}

export const gewaspercelen = atom<unknown>();
export const verdelingGrondsoorten = atom<VerdelingGrondsoort[]>([]);
export const filteredVerdelingGrondsoorten = atom(get => (get(verdelingGrondsoorten) || []).filter(item => item.grondsoortcategorieId !== get(onbekendId)));
